import { Link } from "react-router-dom";
import "../Privacy/privacy.css";

export default function Support() {
  return (
    <main className="Privacy">
      <Link to="/">Back to Winkd</Link>
      <h1>Winkd Support</h1>
      <p>
        Need help with your account, a post, or text chat? Contact Macaroni
        Studios LLC at <a href="mailto:anthony.stuvecke@winkd.com">anthony.stuvecke@winkd.com</a>.
      </p>
      <p>
        Include your app version, device model, and a description of the issue.
        Never send your password or a sign-in code. Avoid including private
        messages or someone else's personal information unless needed to explain
        a safety issue.
      </p>
      <h2>Signing in</h2>
      <p>
        Use the email address associated with your account, or the Apple or
        Google sign-in option you used before. Check your spam folder if an
        email code does not arrive. Contact us if you cannot access your account.
      </p>
      <h2>Safety and reporting</h2>
      <p>
        Use the in-app report and block controls for unwanted interactions or
        inappropriate content. You can also contact support with the relevant
        username or post details. If someone is in immediate danger, contact
        local emergency services.
      </p>
      <h2>Delete your account or request your information</h2>
      <p>
        In Winkd, open <strong>Settings → Account → Delete Account</strong>.
        If you cannot access the app, email support for help with deletion,
        access, or correction requests. We may need to verify account ownership.
      </p>
      <p>
        Our <Link to="/privacy-policy">Privacy Policy</Link> explains information
        collection, service providers, retention, and account deletion. Please
        also read our <Link to="/user-guidelines">User Guidelines</Link> and{" "}
        <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>.
      </p>
    </main>
  );
}
